import { render, staticRenderFns } from "./EatsRewardEditor.vue?vue&type=template&id=c84980f4&scoped=true"
import script from "./EatsRewardEditor.vue?vue&type=script&lang=ts"
export * from "./EatsRewardEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84980f4",
  null
  
)

export default component.exports